export class RolloutStrategyAttribute {
    constructor(init) {
        Object.assign(this, init);
    }
}
//# sourceMappingURL=rollout-strategy-attribute.js.map